export const bloodGroupList = [
  { title: "A1+ve", value: "A1+ve" },
  { title: "A1-ve", value: "A1-ve" },
  { title: "A1B+ve", value: "A1B+ve" },
  { title: "A+ve", value: "A+ve" },
  { title: "A-ve", value: "A-ve" },
  { title: "B+ve", value: "B+ve" },
  { title: "B-ve", value: "B-ve" },
  { title: "O+ve", value: "O+ve" },
  { title: "O-ve", value: "O-ve" },
  { title: "AB+ve", value: "AB+ve" },
  { title: "AB-ve", value: "AB-ve" },
];

export const monthsList = [
  { title: "January", value: "January" },
  { title: "February", value: "February" },
  { title: "March", value: "March" },
  { title: "April", value: "April" },
  { title: "May", value: "May" },
  { title: "June", value: "June" },
  { title: "July", value: "July" },
  { title: "August", value: "August" },
  { title: "September", value: "September" },
  { title: "October", value: "October" },
  { title: "November", value: "November" },
  { title: "December", value: "December" },
];

